import { render, staticRenderFns } from "./Busca-3.vue?vue&type=template&id=4bb47c2c&scoped=true&"
import script from "./Busca-3.vue?vue&type=script&lang=js&"
export * from "./Busca-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb47c2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb47c2c')) {
      api.createRecord('4bb47c2c', component.options)
    } else {
      api.reload('4bb47c2c', component.options)
    }
    module.hot.accept("./Busca-3.vue?vue&type=template&id=4bb47c2c&scoped=true&", function () {
      api.rerender('4bb47c2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/recursos/Busca-3.vue"
export default component.exports